import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export namespace NCmsQuickLinks {
    export interface IComponentData extends NICmsContentComponent.IData {
        /**
         * Links list
         */
        links?: IQuickLink[];
    }
    /**
     * Link interface
     */
    export interface IQuickLink {
        // image?: string;
        /**
         * Link label
         */
        label: string;
        /**
         * Link reference
         */
        link: string;
    }
}
@ICmsComponent<CmsQuickLinksComponent>({
    id: 'quick-links',
    name: 'Quick Links',
    tags: ['PLP', 'Links'],
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'links',
            title: 'Links',
            default: <NCmsQuickLinks.IQuickLink[]>[
                {
                    label: 'Lorem ipsum',
                    link: '/'
                },
                {
                    label: 'Dolor',
                    link: '/'
                },
                {
                    label: 'Sit amet',
                    link: '/'
                }
            ],
            itemName: 'Link',
            required: true,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    title: 'Label',
                    key: 'label',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'link',
                    title: 'Link',
                    required: true
                }
            ]
        }
    ]
})
@Component({
    selector: 'cms-quick-links',
    templateUrl: './cms-quick-links.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [HrefComponent, CommonModule, ICmsClientModule]
})
export class CmsQuickLinksComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsQuickLinks.IComponentData;
}
